<template>
  <base-section class="text-center text-white" info>
    <base-header no-bottom-margin>
      <slot />
    </base-header>
  </base-section>
</template>

<script>
export default {
  name: 'BaseBanner'
}
</script>
